<template>
  <!-- .et ex-tool -->
  <div>
    <div class="et" >
      <div class="item" v-if="false&&curIndex == 'needs'"  @click="toolHandle('talk')" style="height:1.15rem">
        <img src="@/assets/img/live/tool-icon-free.png" class="img2 icon" style="height:1.15rem;width:auto"/>
      </div>
      <div class="item  item_gx" v-if="curIndex == 'needs'"  @click="toolHandle('fb')">
        <img src="@/assets/img/new/supply_ic.png" class="img2 icon" />
      </div>
      <div class="item item_topic" v-if="curIndex == 'hot'"  @click="toolHandle('public')">  
        <img src="@/assets/img/new/topic_ic.png" class="img2 icon" />
      </div>
    </div>


  </div>
</template>
  
<script>
export default {
  name: "ex-tool",
  props:['curIndex'],
  data() {
    return {};
  },
  computed:{
  },
  created(){
  },
  methods: {
      toolHandle(type) {
      this.$emit("toolHandle", type);
    },
  },
};
</script>

<style lang="scss" scoped>
.et {
  position: fixed;
  z-index: 12;
  bottom: 1.18rem;
  right: 0.2rem;
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  width: 1.26rem;
  justify-content: center;
  .item {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    text-align: center;
    align-items: center;
    justify-content: center;
    margin-top: 0.15rem;
    position: relative;
    &.item_gx{
      box-shadow: 0 0.05rem 0.1rem 0 rgba(255, 92, 0, 0.4);
    }
    &.item_topic{
      box-shadow: 0 0.05rem 0.1rem 0 
		rgba(1, 44, 126, 0.4);
    }
    .icon {
      width: 1rem;
      height: 1rem;
    }
    &.item_gx{
      width:1rem;
      height: 1rem;
      img{
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
  .item3 {
    width: 1rem;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .item2 {
    width: 1.26rem;
    height: 1.26rem;
    border-radius: 50%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    flex-wrap: wrap;
    color: #ff416c;
    padding-top: 0.1rem;
    margin-top: 0.3rem;
    position: relative;

    img {
      display: block;
      width: 1.26rem;
      height: 1.26rem;
      border: 0.04rem solid #fff;
      border-radius: 50%;
    }
    &-txt {
      font-size: 0.2rem;
      position: absolute;
      width: 0.92rem;
      height: 0.38rem;
      line-height: 0.38rem;
      background-color: #fff;
      box-shadow: 0px 0.03rem 0.07rem 0px rgba(0, 0, 0, 0.2);
      border-radius: 0.18rem;
      border: solid 0.02rem #ff4b1b;
      bottom: -0.19rem;
    }
    &.s-red {
      background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%),
        linear-gradient(#fff, #fff);
      color: #fff;
    }
  }
}
.img1 {
  width: 0.35rem;
  height: 0.43rem;
}
.img2 {
  width: 0.4rem;
  height: 0.38rem;
}
.img3 {
  width: 0.37rem;
  height: 0.4rem;
}
.z-side {
  position: relative;
  .list {
    flex: 1;
    width: 3.33rem !important;
    height: 0.92rem;
    position: absolute;
    right: 1.02rem;
    top: 0;
    .list-box {
      width: 100%;
      height: 0.92rem;
      padding-right: 0.16rem;
    }
    .item3 {
      width: 100%;
      height: 0.92rem;
      border: 0.02rem solid #e6b54a;
      border-right-color: transparent;
      background-image: url("../../../assets/img/live/crown.png"),
        linear-gradient(90deg, #4b1248 0%, #9e6a62 49%, #f0c27b 100%),
        linear-gradient(#2b1e08, #2b1e08);
      background-repeat: no-repeat;
      background-position: bottom right, 0% 0%;
      background-size: 0.52rem 0.52rem, auto;
      border-radius: 0.06rem;
      position: relative;
      text-align: left;
      padding: 0.1rem;
      display: flex;
      &::after {
        content: "";
        position: absolute;
        right: -0.18rem;
        top: 50%;
        margin-top: -0.1rem;
        border-width: 0.1rem;
        border-style: solid;
        border-color: transparent;
        border-left-color: #ecbe78;
      }
      .logo {
        width: 0.7rem;
        height: 0.7rem;
        border-radius: 0.02rem;
        border: 0.02rem solid #f0cc3a;
        margin-right: 0.1rem;
      }
      .content {
        width: calc(100% - 0.8rem);
        height: 0.7rem;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        p {
          font-size: 0.2rem;
          color: #fff;
          font-weight: bold;
          margin: 0;
          width: 100%;
          line-height: 1.2;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .txt {
          font-size: 0.16rem;
          color: #fff;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 1.2;
        }
        .tag {
          display: flex;
          .info_img {
            width: 0.46rem;
            height: 0.2rem;
            display: flex;
            img {
              width: 0.2rem;
              height: 0.2rem;
              border-radius: 50%;
              border: 1px solid #fff;
              // object-fit: cover;
              &:nth-child(1) {
                position: relative;
                z-index: 3;
              }
              &:nth-child(2) {
                position: relative;
                z-index: 2;
                margin-left: -0.07rem;
              }
              &:nth-child(3) {
                position: relative;
                z-index: 1;
                margin-left: -0.06rem;
              }
            }
          }
          span {
            font-size: 0.14rem;
            margin-left: 0.1rem;
            line-height: 0.2rem;
          }
        }
      }
    }
  }
}
</style>